import { ActivityTypeData } from '@apeiron/common'
import useMakeActivity from '@src/deserialize/hook/useMakeActivity'
import useMakeFilter from '@src/deserialize/hook/useMakeFilter'
import { ActivityFilterData } from '@src/types/activityFilter'
import * as R from 'ramda'
import { useCallback } from 'react'

const useMakeActivityFilter = (): Hook => {
  const { makeClipFilter } = useMakeFilter<ActivityTypeData>()

  const { makeActivityTypeData } = useMakeActivity()

  // public
  const makeActivityFilter = useCallback(
    (input: any): ActivityFilterData => {
      return {
        type: makeClipFilter(R.propOr({}, 'type', input), makeActivityTypeData)
      }
    },
    [makeActivityTypeData, makeClipFilter]
  )

  return {
    makeActivityFilter
  }
}

type Hook = {
  makeActivityFilter: (input: any) => ActivityFilterData
}

export default useMakeActivityFilter
